/**
 * General Step View component for viewing scenario general information
 */
import {
    Box,
    Typography,
} from '@mui/material';
import React from 'react';
import { ScenarioResponse } from '../types/scenario';

interface GeneralStepViewProps {
  scenario: ScenarioResponse;
  onBack: () => void;
}

export const GeneralStepView: React.FC<GeneralStepViewProps> = ({
  scenario,
  onBack,
}) => {
  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        {scenario.name}
      </Typography>
    </Box>
  );
};
